import React from 'react';
import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';

import * as api from '../../api/api';

class AddCustomContentModal extends React.Component {
    constructor(props) {
        super(props);

        this.handleOkButtonClick = this.handleOkButtonClick.bind(this);
    }

    handleOkButtonClick() {

        this.props.updateLoader({
            loaded: false,
            message: ""
        });

        if (this.state.file.type.indexOf("video/") === -1 && this.state.file.type.indexOf("image/") === -1) {
            this.props.updateLoader({
                loaded: true,
                message: "Ошибка при сохранении: возможна загрузка только изображений или видео"
            });

            return;
        }

        //если это видео, проверим его длительность
        if (this.state.file.type.indexOf("video/") !== -1) {

            let video = document.createElement('video');
            video.preload = 'metadata';
            video.src = URL.createObjectURL(this.state.file);

            video.onloadedmetadata = () => {

                window.URL.revokeObjectURL(video.src);

                if (video.duration > 30) {
                    this.props.updateLoader({
                        loaded: true,
                        message: "Ошибка при сохранении: длительность файла не должна превышать 30 с."
                    });
                }
                else {
                    const data = new FormData()
                    data.append('file', this.state.file);

                    api.makeRequest(api.saveCustomContentFile(data)).then(
                        (result) => {
                            this.props.onSuccess();
                        },
                        (error) => {
                            this.props.updateLoader({
                                loaded: true,
                                message: "Ошибка при сохранении: " + error
                            });
                        }
                    );
                }
            }
        }
        else {
            const data = new FormData()
            data.append('file', this.state.file);

            api.makeRequest(api.saveCustomContentFile(data)).then(
                (result) => {
                    this.props.onSuccess();
                },
                (error) => {
                    this.props.updateLoader({
                        loaded: true,
                        message: "Ошибка при сохранении: " + error
                    });
                }
            );
        }
    }

    render() {
        return (
            <div className="modal fade" id="addCustomContentModal" tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Добавить медиафайл</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <input
                                type="file"
                                onChange={(event) => this.setState({ file: event.currentTarget.files[0] })}
                            />

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Отмена</button>
                            <button type="button" className="btn btn-primary-custom" data-dismiss="modal" onClick={this.handleOkButtonClick}>OK</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AddCustomContentModal;